import type { RunBundle } from "@game/simulation/types.js";

const LAST_BUNDLE_KEY = "trash-panic:last-run-bundle";

export function saveRunBundle(bundle: RunBundle): void {
  try { localStorage.setItem(LAST_BUNDLE_KEY, JSON.stringify(bundle)); } catch { /* export remains available in memory */ }
}

export function loadRunBundle(): RunBundle | null {
  try {
    const raw = localStorage.getItem(LAST_BUNDLE_KEY);
    return raw ? JSON.parse(raw) as RunBundle : null;
  } catch { return null; }
}

export function exportRunBundle(bundle: RunBundle): void {
  const blob = new Blob([JSON.stringify(bundle, null, 2)], { type: "application/json" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `trash-panic-${bundle.seed.id}-${bundle.runId}.json`;
  link.click();
  setTimeout(() => URL.revokeObjectURL(link.href), 0);
}
